<template>
  <section class="our-products-section">
    <div class="container">
      <div class="section-content">
        <div class="section-tag">
          <div class="what-we-offer">What we offer</div>
        </div>
        <h2 class="section-title">Our Products</h2>
        <i class="section-subtitle"
          >Comprehensive AI-powered solutions for trade finance and business
          intelligence</i
        >
      </div>

      <div class="products-grid">
        <!-- Business Information Reports - Full Width Card with Image Below Text -->
        <div class="product-card full-width">
          <div class="card-content">
            <h3 class="card-title">Business Information Reports</h3>
            <p class="card-description">
              Our business information reports are compiled from public
              registries, official documents and include trade transactions,
              legal cases, and compliance checks, ensuring reliability and
              accuracy.
            </p>
          </div>
          <div class="card-image clipped">
            <img
              class="data-network-illustration"
              alt=""
              :src="getCDNlink('assets/new-assets/Product-1.webp')"
            />
          </div>
        </div>

        <!-- Interactive Reports Card -->
        <div class="product-card">
          <div class="card-content">
            <h3 class="card-title">
              Interactive Reports & Conversational Intelligence : Insight Lens
            </h3>
            <p class="card-description">
              Interactive business reports designed for modern users. Ask
              questions in natural language and get precise, targeted answers
              instantly.
            </p>
          </div>
          <div class="card-image clipped small-cards">
            <img
              class="data-network-illustration"
              alt=""
              :src="getCDNlink('assets/new-assets/Product-2.webp')"
            />
          </div>
        </div>

        <!-- Creda Conversational Insights Card -->
        <div class="product-card">
          <div class="card-content">
            <h3 class="card-title">
              "Creda" Conversational Insights with AI Chatbot
            </h3>
            <p class="card-description">
              Conversations for instant business insights covering several
              entities. Transform the traditional "Download & Read" into an "Ask
              & Know" experience.
            </p>
            <div class="development-badge">Limited release</div>
          </div>
          <div class="card-image clipped small-cards">
            <img
              class="data-network-illustration"
              alt=""
              :src="getCDNlink('assets/new-assets/Product-3.webp')"
            />
          </div>
        </div>

        <!-- Global Company Search Card -->
        <div class="product-card">
          <div class="card-content">
            <h3 class="card-title">Global Company Search</h3>
            <p class="card-description">
              Access our database of 350 million+ entities worldwide. Find
              detailed information on companies across global markets.
            </p>
          </div>
          <div class="card-image clipped small-cards">
            <img
              class="data-network-illustration"
              alt=""
              :src="getCDNlink('assets/new-assets/Product-4.webp')"
            />
          </div>
        </div>

        <!-- Trade Risk Intelligence Card -->
        <div class="product-card">
          <div class="card-content">
            <h3 class="card-title">Trade Risk Intelligence</h3>
            <p class="card-description">
              Comprehensive reports include shipment history, products traded,
              and trade corridors.
            </p>
          </div>
          <div class="card-image clipped small-cards">
            <img
              class="data-network-illustration"
              alt=""
              :src="getCDNlink('assets/new-assets/Product-5.webp')"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from "@/config";

export default {
  name: "OurProducts",

  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
  },
};
</script>

<style scoped>
.our-products-section {
  width: 100%;
  position: relative;
  background: linear-gradient(78.13deg, #edf8ff, #eff1ff);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 55px;
  text-align: center;
  font-size: 16px;
  color: #046BE1;
  font-family: Figtree;
  padding: 80px 140px;
}

.container {
  margin: 0;
  width: -webkit-fill-available;
}

/* Header Section */
.what-we-offer {
  position: relative;
  line-height: 140%;
  font-weight: 500;
}
.section-tag {
  display: inline-flex;
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: left;
  font-size: 14px;
}
.section-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
  margin-top: 1rem;
  background: linear-gradient(-72.07deg, #046BE1 19%, #224096 64%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.section-subtitle {
  color: #1c1c1c;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 30px;
  text-align: center;
  font-style: normal;
}
.section-content {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  font-size: 16px;
  color: #046BE1;
  font-family: Figtree;
}

/* Products Grid */
.products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

/* Product Cards */
.product-card {
  background-color: #ffffff;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.full-width {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column; /* Changed to column for first card */
}

.card-content {
  padding: 2rem;
  flex: 1;
  text-align: left;
}

.card-title {
  color: #1e3a8a;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 0.5rem;
}

.card-description {
  color: #1c1c1c;
  font-size: 18px;
  line-height: 1.2;
  margin: 0;
}

.development-badge {
  display: inline-block;
  background-color: #ffffff;
  border: 1px solid #046BE1;
  color: #046BE1;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  margin-top: 1rem;
}

.card-image {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  min-height: 150px;
}

/* Special styling for the first card image */
.full-width .card-image {
  padding: 0 2rem 2rem;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  min-height: 120px;
  background: linear-gradient(135deg, #046BE1 0%, #9333ea 100%);
  border-radius: 0.5rem;
  position: relative;
  overflow: hidden;
}

.card-image.clipped {
  height: 100px; /* adjust height as needed */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start; /* align top of the image */
}

.small-cards {
  justify-content: flex-end !important;
}

.card-image.clipped img {
  width: auto;
  max-width: 50%;
  height: auto;
  display: block;
}

/* Make the first card image taller */
.full-width .image-placeholder {
  min-height: 180px;
}

.image-placeholder::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

/* Responsive Styles */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .title {
    font-size: 2.25rem;
  }

  .subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 767px) {
  .our-products-section {
    padding: 45px 40px;
  }
  .what-we-offer {
    font-size: 14px;
  }
  .section-tag {
    padding: 10px 12px;
  }
  .section-title {
    font-size: 36px;
    margin-top: 10px;
    margin-bottom: 0;
  }
  .card-image.clipped {
    min-height: 65px;
    height: 40px;
    padding: 0 2rem 2rem;
  }
  .small-cards {
    min-height: 94px !important;
  }
  .card-image.clipped.small-cards img {
    width: auto;
    max-width: 30%;
  }
  .card-description {
    font-size: 14px;
  }
  .card-content {
    padding: 15px 10px 0px;
  }
  .section-subtitle {
    font-size: 16px;
    margin-top: 12px;
    margin-bottom: 15px;
  }
  .products-grid {
    grid-template-columns: 1fr;
  }
  .section-content {
    gap: 0px;
  }
  .title {
    font-size: 2rem;
  }

  .card-title {
    font-size: 1.125rem;
    margin: 0 0 0.2rem;
  }
}

@media (max-width: 480px) {
  .card-image.clipped {
    padding: 0 2rem 1rem;
    min-height: 32px;
    height: 32px;
  }
  .our-products-section {
    padding: 25px;
  }
  .small-cards {
    min-height: 30px !important;
  }
}
</style>
